export default (id, item) => ({
	id,
	price: item.price,
	discountedPrice: item.discountedPrice,
	amount: item.amount,
	title: item.title,
	cover: item.cover,
	get total() {
		return this.amount * this.applicablePrice
	},
	get formattedUndiscountedTotal() {
		return this.format(this.amount * this.price)
	},
	get formattedTotal() {
		return this.format(this.total)
	},
	get formattedPrice() {
		return this.format(this.price)
	},
	get formattedDiscountedPrice() {
		return this.format(this.discountedPrice)
	},
	get applicablePrice() {
		if (this.isDiscounted) {
			return this.discountedPrice;
		}
		return this.price;
	},
	get isDiscounted() {
		return (this.discountedPrice != false)
	},
	format(value) {
		const formatter = new Intl.NumberFormat('en-GB', {
		  style: 'currency',
		  currency: 'GBP',
		});
		return formatter.format(value)
	},
	updateAmount() {
		this.amount = parseInt(this.amount)
		if (this.amount === 0) {
			this.$store.cart.removeItem(this.id)
		} else {
			console.log(this.id)
			this.$store.cart.changeItemAmount(this.id, this.amount)
		}
	}
})